export default __webpack_public_path__ + "static/Plots0021-0d9d64590fb43cbbfb3d4d2e4b2a3fb3.jpg";